module.exports = __webpack_public_path__ + "static/img/4.7dac2af.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/zh/4.png
// module id = vTBH
// module chunks = 0